import React, {useState } from 'react';
import InputElement from '../Element/InputElement';
import capitalize from 'capitalize';
import FormErrorBanner from '../Element/FormErrorBanner';
import CasePrefPicker from './CasePrefPicker';


function LawFirmProfile({
      values,
      errors,
      touched,
      handleBlur,
      handleChange,
      setFieldValue,
      handleSubmit,
      buttonLabel,
      disableFirmSelection = false,
      casePref,
      setCasePref,      // pass both to show the optional case-type preference (sign-up)
})
{

  const handleFocus = (e) => 
  {
    setApiError("");
  }

   const [apiError, setApiError] = useState("");


  
  return (
    
      <div className='p-2 lg:p-10 w-full bg-white'>
      
      <FormErrorBanner>{apiError}</FormErrorBanner>
      <div className='flex w-full lg:gap-2 flex-col lg:flex-row mb-2 ' >
        
        <div className='w-full'>
          <InputElement
              handleChange={(e) =>setFieldValue("firstName", capitalize(e.target.value))}
              handleBlur={handleBlur}
              handleFocus={handleFocus}
              label = "First name"
              name = "firstName"
              placeholder= "--Enter your first name--"
              value = {values.firstName}
              labelError={errors.firstName}
              labelTouched={touched.firstName}
              ignoreLabel={false}
              labelStyle=" text-navy"
          />
        </div>
        <div className='w-full  '>
          <InputElement
                handleChange={(e) => setFieldValue("lastName", capitalize(e.target.value))}
                handleBlur={handleBlur}
                handleFocus={handleFocus}
                label = "Last name"
                name = "lastName"
                placeholder= "--Enter your last name--"
                value = {values.lastName}
                labelError={errors.lastName}
                labelTouched={touched.lastName}
                labelStyle=" text-navy"
            />
        </div>
      </div>
         <div className='flex w-full  flex-col  mb-2 ' >
        
        {/* <LawFirmAutoComplete
        isFormFilled={isFormFilled}
        setIsFormFilled={setIsFormFilled}
         lawFirmId={values.lawFirmId}
         setFieldValue={setFieldValue}
        /> */}
        {
          disableFirmSelection ?
          <div className=' w-full  text-xs lg:text-base '>
          <div className=' w-full'>
              <div className='font-semibold mb-1 mt-2 text-xs lg:text-sm text-navy font-plexsans'>Law Firm</div>
              <div className='w-full rounded-md border border-gray-200 bg-cream py-2.5 px-3 text-navy font-plexsans text-xs lg:text-sm'>{values.company}</div>
          </div>
          <div className=' w-full mt-2 '>
              <div className='font-semibold mb-1 mt-2 text-xs lg:text-sm text-navy font-plexsans'>Law Firm Website</div>
              <div className='w-full rounded-md border border-gray-200 bg-cream py-2.5 px-3 text-navy font-plexsans text-xs lg:text-sm'>{values.lawFirmLink}</div>
            </div>
          </div>
          :
          <>
            <div className=' w-full '>
                <InputElement
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    handleFocus={handleFocus}
                    placeholder = "--Enter law firm name--"
                    name = "company"
                    label= "Law Firm name"
                    value = {values.company}
                    labelError={errors.company}
                    labelTouched={touched.company}
                    labelStyle=" text-navy"
                  />
            </div>
            <div className=' w-full '>
                <InputElement
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    handleFocus={handleFocus}

                    placeholder = "--Enter the law firm website link--"
                    name = "lawFirmLink"
                    label= "Law firm website link"
                    value = {values.lawFirmLink}
                    labelError={errors.lawFirmLink}
                    labelTouched={touched.lawFirmLink}
                    labelStyle=" text-navy"
                  />
            </div>
          </>
        }

          <div className=' w-full '>
              <InputElement
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  handleFocus={handleFocus}
                  placeholder = "--Enter the law firm phone number--"
                  name = "phoneNumber"
                  label= "Law firm phone number"
                  value = {values.phoneNumber}
                  labelError={errors.phoneNumber}
                  labelTouched={touched.phoneNumber}
                  labelStyle=" text-navy"
                />
          </div>
         
        </div>
         
        {setCasePref &&
          <div className='w-full mt-4'>
            <CasePrefPicker value={casePref} onChange={setCasePref} />
          </div>}

        <div className={'flex mt-2 lg:mt-8 gap-2 text-sm lg:text-md lg:flex lg:justify-center font-bold '}>
              {/* <div 
                className=
                {
                  "w-full lg:w-auto lg:px-24 h-10 bg-sky-500 hover:bg-sky-600 text-white rounded mt-5 flex justify-center items-center cursor-pointer shadow-xl "
                + (isFormFilled ? 'opacity-100' : 'opacity-50 cursor-not-allowed')
                }
                onClick={handleSubmit}>
                  {userDetails.verified ? 
                  "Save updates"
                  :
                 ( showBack ? 
                  "Submit "
                :
                 "Submit For Review" 
                )
                  }
                  </div> */}
                <div
                onClick={handleSubmit}
                className=
                {
                  "w-full lg:w-auto lg:px-24 h-10 bg-tan hover:bg-tanDark text-ivory rounded mt-5 flex justify-center items-center cursor-pointer shadow-xl "
                    }>
                  {buttonLabel ? buttonLabel : "Next ->"}
                </div>
                
              </div>
                {/* <div className="w-full mt-10 ">
                  <LawFirmMatches 
                  matchingFirms={matchingFirms}
                  selectedFirm={selectedFirm}
                  setSelectedFirm={setSelectedFirm}
                  />
                  </div> */}
              {/* {showBack ? <div 
              className="w-full lg:w-auto px-5 h-10 bg-gray-400 hover:bg-gray-600 text-white rounded mt-5 flex justify-center items-center cursor-pointer shadow-xl"
              onClick={()=>setShowEdit(false)} >Back</div>
            :
            ''} */}
        </div>
  )
}

export default LawFirmProfile
